import React from "react";
import { useTranslation } from "react-i18next";
import ModalIndex from "@Modals/layout/index";
import { BackIcon } from "@routes/IconeSvg";
import { FloatButton } from "@components/tailwindComponents";

export default function ModalBackConfirmation({
  isOpen,
  onCloseModal,
  isLoading = false,
  handleSave,
  colorBtn = "blue",
  content,
  onBack = null,
  onClick = null,
  hideText = false,
  wait = false,
  backText = null,
  backIcon = null,
  withCloseCroix = false
}) {
  const { t } = useTranslation("components.generale");

  return (
    <ModalIndex
      isOpen={isOpen}
      onClickClose={onCloseModal}
      isLoading={isLoading}
      withCloseCroix={withCloseCroix}
      buttonOptions={{
        click: handleSave,
        color: colorBtn,
        title: t("Enregistrer et quitter")
      }}
      buttonCancelOptions={{
        click: onCloseModal,
        color: "outlined",
        title: t("Quitter sans enregistrer")
      }}
      widthType="medium"
    >
      <div className="arh-flex arh-flex-col arh-w-full">
        {/* Bouton Retour */}
        <div
          className={`arh-flex arh-items-center arh-space-x-2 arh-absolute arh-top-6 arh-left-4 ${wait ? "arh-cursor-wait" : "arh-cursor-pointer"
            }`}
          onClick={wait ? null : (onBack || onClick || onCloseModal)}
        >
          <FloatButton
            size="arh-w-10 arh-h-10"
            color="arh-bg-transparent hover:arh-bg-gray-200 active:arh-bg-greyActive !arh-border-transparent"
          >
            {backIcon || <BackIcon />}
          </FloatButton>

          {!hideText && (
            <span className="arh-font-poppins arh-font-normal arh-text-black mobile-768:arh-hidden">
              {backText || t("Retour à la page")}
            </span>
          )}
        </div>

        {/* Contenu principal */}
        <div className="arh-flex arh-flex-col arh-w-full arh-items-center arh-justify-center arh-pt-16 arh-gap-6">
          <p className="arh-font-poppins arh-text-[27px] arh-font-bold arh-text-darkColor">
            {content}
          </p>
        </div>
      </div>
    </ModalIndex>
  );
}